const environment = { test : "http://localhost:8000/api/v2", live : "https://web3.lagosstate.gov.ng/api/v2" }

const env = environment.live

export { env }